document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.querySelector('button[name="add"]');
  if (!addToCartButton) {
    console.error('Add to Cart button not found');
    return;
  }

  addToCartButton.addEventListener('click', (event) => {
    function logEvent(eventName, params = {}) {
      if (typeof window !== 'undefined') {
        if (window.clarity) {
          window.clarity('event', eventName);
        }
        if (window.gtag) {
          gtag('event', eventName, params);
        }
      }
    }
    if (!window.hasGeneratedImages()) {
      event.preventDefault(); // Only prevent if condition fails
      logEvent('add_to_cart_without_preview');
      window.openImageUploadModal();
      return;
    }

    const form = addToCartButton.closest('form');
    // the size picked on the page (wb-pdp size cards)
    const chosen = document.querySelector('[data-wb-sizes] input:checked');
    // TESTING ONLY: the sample "Digital file" row (?wbdigital=1) has no real variant behind it
    if (chosen && chosen.hasAttribute('data-fake')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.alert('Test only: this store has no "Digital file" variant yet. Add it in Shopify, then this button adds it to the cart.');
      return;
    }

    // v2 builder: the chosen preview + version, size comes from the variant
    const previewId = window.getPreviewId && window.getPreviewId();
    if (previewId) {
      const setProp = (name, value) => {
        let input = form.querySelector('input[name="properties[' + name + ']"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          form.appendChild(input);
        }
        input.value = value;
      };
      setProp('_previewId', previewId);
      setProp('_version', window.getSelectedVersion() || '2');
      setProp('_thumbnail', window.getSelectedImage()?.thumbnailUrl || '');
      // digital file: no canvas, delivered by email (handled by hand for now)
      const format = form.querySelector('input[name="properties[_format]"]');
      if (chosen && chosen.hasAttribute('data-digital')) setProp('_format', 'digital');
      else if (format) format.remove();
      // no preview id in analytics: it opens the preview (the child's portrait) for whoever holds it
      logEvent('add_to_cart_clicked', { version: window.getSelectedVersion(), variant_id: form.querySelector('input[name="id"]')?.value || '' });
      return;
    }

    const inputJobId = document.createElement('input');
    inputJobId.type = 'hidden';
    inputJobId.name = 'properties[jobId]';
    inputJobId.value = window.getJobId();
    form.appendChild(inputJobId);

    const inputVariant = document.createElement('input');
    inputVariant.type = 'hidden';
    inputVariant.name = 'properties[selectedVariant]';
    inputVariant.value = window.getSelectedImageVariant();
    form.appendChild(inputVariant);

    logEvent('add_to_cart_clicked', { variant_id: inputVariant.value });

    const inputThumbnail = document.createElement('input');
    inputThumbnail.type = 'hidden';
    inputThumbnail.name = 'properties[_thumbnail]';
    inputThumbnail.value = window.getSelectedImage()?.thumbnailUrl || '';
    form.appendChild(inputThumbnail);
  });
});
